import { css } from '@emotion/css'
import { colors, fontWeight, spacing } from '@offerzen/pinata'

const styles = {
  appliedContent: css({
    display: 'grid',
    gap: spacing.default,

    h4: {
      color: colors.oxfordBlue,
      fontWeight: fontWeight.medium,
      marginBottom: 0,
    },

    'p, dt': {
      color: colors.scorpion,
    },

    p: {
      margin: 0,
    },

    dt: {
      fontWeight: fontWeight.regular,
    },
  }),

  status: css({
    display: 'flex',
    alignItems: 'center',
    gap: spacing.small,
  }),
}

export default styles
